<template>
<div>
  <Form :fnoname="'200.00'" :fnoperiod="'quarter'" :fnotitle="'Декларация по индивидуальному подоходному налогу и социальному налогу'"></Form>
</div>
</template>

<script>
import Form from "@/components/reports/Form";
export default {
  name: "Form200.00",
  components: {
    Form
  }
}
</script>

<style scoped>

</style>